import { motion } from 'framer-motion';
import { CalendarDays, ClipboardCheck, GraduationCap, MessageSquare, Stethoscope, Users } from 'lucide-react';

const DATA_CARDS = [
  { icon: CalendarDays, label: 'Attendance 94%', color: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/20' },
  { icon: GraduationCap, label: 'IA: 36/40', color: 'bg-amber-500/20 text-amber-300 border-amber-500/20' },
  { icon: MessageSquare, label: 'Feedback 4.3★', color: 'bg-violet-500/20 text-violet-300 border-violet-500/20' },
  { icon: Stethoscope, label: 'Rotation: GM', color: 'bg-sky-500/20 text-sky-300 border-sky-500/20' },
  { icon: ClipboardCheck, label: 'Leave: 2 days', color: 'bg-rose-500/20 text-rose-300 border-rose-500/20' },
  { icon: CalendarDays, label: 'Session: Anat', color: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/20' },
  { icon: GraduationCap, label: 'IA: Pass', color: 'bg-amber-500/20 text-amber-300 border-amber-500/20' },
  { icon: MessageSquare, label: 'Survey done', color: 'bg-violet-500/20 text-violet-300 border-violet-500/20' },
];

function FloatingCard({ card, index, lane }) {
  const duration = 7 + (index % 3) * 1.5;
  const startDelay = index * 1.2 + lane * 0.4;
  const Icon = card.icon;
  return (
    <motion.div
      className={`absolute flex items-center gap-2 px-3 py-2 rounded-xl border backdrop-blur-sm text-xs font-medium whitespace-nowrap ${card.color}`}
      style={{ left: `${15 + lane * 30}%` }}
      animate={{ y: ['110%', '-130%'], opacity: [0, 1, 1, 0], scale: [0.9, 1, 1, 0.95] }}
      transition={{ duration, delay: startDelay, repeat: Infinity, repeatDelay: 1.5, ease: 'linear', times: [0, 0.12, 0.85, 1], opacity: { duration, times: [0, 0.12, 0.85, 1] }, scale: { duration, times: [0, 0.12, 0.85, 1] } }}
    >
      <Icon className="w-3.5 h-3.5 shrink-0" />{card.label}
    </motion.div>
  );
}

export default function RightDataFlow() {
  return (
    <div className="relative">
      <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-[#DDE8E1] via-transparent to-[#E4DDF0] opacity-50" />
      <div className="relative rounded-[1.75rem] border border-stone-200/80 overflow-hidden shadow-[0_30px_80px_rgba(28,48,39,0.12)]" style={{ background: 'linear-gradient(175deg, #1a3328 0%, #142a20 50%, #12201c 100%)' }}>
        <div className="h-[430px] relative overflow-hidden">
          {[0, 1, 2].map((lane) => (<div key={lane} className="absolute top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/[0.06] to-transparent" style={{ left: `${25 + lane * 25}%` }} />))}
          {DATA_CARDS.map((card, i) => (<FloatingCard key={i} card={card} index={i} lane={i % 3} />))}
          {[35, 55].map((top, i) => (
            <div key={top} className="absolute left-[10%] right-[10%] h-px" style={{ top: `${top}%` }}>
              <div className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
              <div className="absolute left-1/2 -translate-x-1/2 -top-2.5 px-2 py-0.5 rounded bg-white/[0.06] border border-white/[0.08] text-[9px] text-white/30 uppercase tracking-widest">{i === 0 ? 'Process' : 'Merge'}</div>
            </div>
          ))}
          <motion.div className="absolute top-[8%] left-1/2 -translate-x-1/2 flex items-center gap-2 px-4 py-2.5 rounded-2xl bg-white/10 border border-white/15 backdrop-blur-md" animate={{ boxShadow: ['0 0 20px rgba(100,200,150,0)', '0 0 20px rgba(100,200,150,0.15)', '0 0 20px rgba(100,200,150,0)'] }} transition={{ duration: 3, repeat: Infinity }}>
            <Users className="w-4 h-4 text-white/70" /><span className="text-xs font-semibold text-white/80" style={{ fontFamily: 'Outfit' }}>Unified Profile</span>
          </motion.div>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0f2018]/95 to-transparent p-5 pt-10 text-white">
          <p className="text-[10px] uppercase tracking-[0.16em] text-white/50">Data Flow</p>
          <p className="mt-1.5 text-base font-medium text-white/90" style={{ fontFamily: 'Outfit' }}>Every data point merges into one unified view</p>
        </div>
      </div>
    </div>
  );
}
